import React from 'react';
import { SEAL_COLORS } from '../utils/sovereigntyConstants';

interface SealBadgeProps {
  /** SEAL level (0–4) */
  level: number;
  /** Display label for the SEAL level */
  label: string;
}

/**
 * Small inline badge showing a SEAL level number and label.
 * White text on a colored pill-shaped background.
 */
export const SealBadge: React.FC<SealBadgeProps> = ({ level, label }) => {
  const bgColor = SEAL_COLORS[level] ?? '#A1A7AE';

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        background: bgColor,
        color: '#fff',
        borderRadius: 999,
        padding: '2px 10px',
        fontSize: 12,
        fontWeight: 600,
        lineHeight: 1.4,
        whiteSpace: 'nowrap',
      }}
      aria-label={`SEAL-${level}: ${label}`}
    >
      <span style={{ fontWeight: 700 }}>{level}</span>
      <span>{label}</span>
    </span>
  );
};
